import styled from 'styled-components';
import { StyledButton as Button } from '../../../../CommonComponents/Button';

export const Item = styled.div`
  margin-bottom: 38px;

  &:first-of-type {
    margin-top: 38px;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const Title = styled.h3`
  color: #333;
  font-size: 16px;
  margin: 0 0 6px 0;
  font-weight: 400;
`;

export const Message = styled.p`
  color: #6C727F;
  font-size: 15px;
  line-height: 21px;
  margin: 6px 0;
`;

export const ActionAnchor = styled.a.attrs(() => ({
  target: '_blank',
  rel: 'noopener noreferrer',
}))`
  font-size: 14px;
  color: #5abee4;
  cursor: pointer;
  font-weight: 600;

  i {
    margin-left: 6px;
  }
`;

export const ActionButton = styled(Button.Link)`
  font-size: 14px;
  color: #5abee4;
  font-weight: 600;
`;

export const LinkButton = styled(Button.Link)`
  font-size: 14px;
  color: #5abee4;
  font-weight: 600;
`;

export const OrderedList = styled.ol`
  padding-left: 18px;

  li {
    color: #6C727F;
    font-size: 15px;
    line-height: 21px;
    margin: 12px 0;
  }
`;
